module.exports = __webpack_public_path__ + "static/media/member services icon (active).ed057e32.svg";